/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import photo1 from "assets/images/sonorisation-1.jpg";
import photo2 from "assets/images/sonorisation-2.jpg";
import photo3 from "assets/images/sonorisation-3.jpg";
import photo4 from "assets/images/sonorisation-4.jpg";
import photo5 from "assets/images/sonorisation-5.jpg";
import photo6 from "assets/images/sonorisation-6.jpg";

export default [
  {
    title: "Sonorisation conférence et évènementiel",
    description: "L'Excellence Sonore au Cœur de Vos Évènements",
    items: [
      {
        image: photo1,
      },
      {
        image: photo2,
      },
      {
        image: photo3,
      },
      {
        image: photo4,
      },
      {
        image: photo5,
      },
      {
        image: photo6,
      },
    ],
  },
];
